import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Block, Image } from '@comp/crRender'
import PricingQuotationPopup from './PricingQuotationPopup'
import BaseBtn from '../../../component/tableDrawer/Tables/Components/TableActions/BaseBtn'
import moment from 'moment'

const APLINK = import.meta.env.VITE_API_URL

const RequestDetailsContent = ({ requestDetails, requestId }) => {
    const { t } = useTranslation()
    const pricingPopupRef = useRef(null)

    const handleOpenPricingPopup = () => {
        pricingPopupRef.current?.click()
    }

    return (
        <Block isRender={!!requestDetails?.orderId} className="request-details-container">
            <div className="request-details-header">
                <h1 className="request-title">{t("request-details")} #{requestDetails?.orderId}</h1>
                <div className="request-actions">
                    <BaseBtn
                        action={"upload-pricing"}
                        onApply={handleOpenPricingPopup}
                        icon={"material-symbols:upload-file"}
                        className="info"
                        reqAction="canAdd"
                    />
                </div>
            </div>

            <div className="request-details-grid">
                <div className="request-info-card">
                    <h3>{t("request-information")}</h3>
                    <div className="info-item">
                        <label>{t("order-id")}:</label>
                        <span>{requestDetails?.orderId}</span>
                    </div>
                    <div className="info-item">
                        <label>{t("order-status")}:</label>
                        <span>{requestDetails?.orderStatus}</span>
                    </div>
                    <div className="info-item">
                        <label>{t("start-date")}:</label>
                        <span>{moment(requestDetails?.startDate).format('DD/MM/YYYY')}</span>
                    </div>
                    <div className="info-item">
                        <label>{t("end-date")}:</label>
                        <span>{moment(requestDetails?.endDate).format('DD/MM/YYYY')}</span>
                    </div>
                </div>

                <div className="request-details-right-column">
                    <div className="user-info-card">
                        <h3>{t("user-info")}</h3>
                        <div className="info-item">
                            <label>{t("user-name")}:</label>
                            <span>{requestDetails?.userName}</span>
                        </div>
                        {requestDetails?.birthDate && (
                            <div className="info-item">
                                <label>{t("birth-date")}:</label>
                                <span>{moment(requestDetails.birthDate).format('DD/MM/YYYY')}</span>
                            </div>
                        )}
                        {requestDetails?.age !== undefined && requestDetails?.age !== null && (
                            <div className="info-item">
                                <label>{t("age")}:</label>
                                <span>{requestDetails.age}</span>
                            </div>
                        )}
                        {requestDetails?.gender !== undefined && requestDetails?.gender !== null && (
                            <div className="info-item">
                                <label>{t("gender")}:</label>
                                <span>{requestDetails.gender === 0 ? t("male") : requestDetails.gender === 1 ? t("female") : requestDetails.gender}</span>
                            </div>
                        )}
                        {requestDetails?.height !== undefined && requestDetails?.height !== null && requestDetails?.height !== 0 && (
                            <div className="info-item">
                                <label>{t("height")}:</label>
                                <span>{requestDetails.height * 100} {t("cm")}</span>
                            </div>
                        )}
                        {requestDetails?.weight !== undefined && requestDetails?.weight !== null && requestDetails?.weight !== 0 && (
                            <div className="info-item">
                                <label>{t("weight")}:</label>
                                <span>{requestDetails.weight} {t("kg")}</span>
                            </div>
                        )}
                        {requestDetails?.isSmoker !== undefined && requestDetails?.isSmoker !== null && (
                            <div className="info-item">
                                <label>{t("is-smoker")}:</label>
                                <span>{requestDetails.isSmoker ? t("Yes") : t("No")}</span>
                            </div>
                        )}
                        {requestDetails?.isDrinkAlcohol !== undefined && requestDetails?.isDrinkAlcohol !== null && (
                            <div className="info-item">
                                <label>{t("is-drink-alcohol")}:</label>
                                <span>{requestDetails.isDrinkAlcohol ? t("Yes") : t("No")}</span>
                            </div>
                        )}
                        {requestDetails?.medicalOperation && (
                            <div className="info-item">
                                <label>{t("medical-operation")}:</label>
                                <span>{requestDetails.medicalOperation}</span>
                            </div>
                        )}
                        {requestDetails?.allergy && (
                            <div className="info-item">
                                <label>{t("allergy")}:</label>
                                <span>{requestDetails.allergy}</span>
                            </div>
                        )}
                        {requestDetails?.regularMedicationName && (
                            <div className="info-item">
                                <label>{t("regular-medication-name")}:</label>
                                <span>{requestDetails.regularMedicationName}</span>
                            </div>
                        )}
                        {requestDetails?.files && requestDetails.files.length > 0 && (
                            <div className="info-item info-item-with-nested">
                                <label>{t("files")}:</label>
                                <div className="files-list">
                                    {requestDetails.files.map((fileGroup, index) => (
                                        <div key={index} className="file-group">
                                            <strong className="file-group-key">{t(fileGroup?.key)}:</strong>
                                            <div className="file-paths">
                                                {fileGroup?.paths?.map((path, pathIndex) => (
                                                    <a
                                                        key={pathIndex}
                                                        href={`${"https://htapi.jozoortech.com/"}${path}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="file-link"
                                                    >
                                                        {t("click-to-open")}
                                                    </a>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="services-card">
                        <h3>{t("services")}</h3>
                        <div className="services-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>{t("service-name")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {requestDetails?.services?.map((service, index) => (
                                        <tr key={index}>
                                            <td>{service}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <PricingQuotationPopup
                modalId={pricingPopupRef}
                requestDetails={requestDetails}
                requestId={requestId}
            />
        </Block>
    )
}

export default RequestDetailsContent

